<!-- 
<div [class]="video_iniciado? 'divLlamada divConLLamada':'divLlamada divSinLLamada' ">
     <div *ngIf="!(video_iniciado)" class="divSinLLamadaCamara"><mat-icon
               style="font-size: 70px;height: auto; width: auto;">videocam</mat-icon></div>
     <div style="height: 5%;"></div>
     <div *ngIf="video_iniciado" class="divVideos">
          <ng-container *ngIf="userVideoList && userVideoList.length >0">
               
               <div class="row contenerdor-pantallas">
                    <div class="divVideosInferior col-md-2 ">
                    </div>
                    <div class="divVideosSuperior col-md-8 p-0">
                         <ng-container *ngFor="let elementoVideo of userVideoList;">
                              <div class="videosSuperior" *ngIf="elementoVideo.idSocket == userVideoSelected">
                                   <div class="video-container">
                                        <p class="nombreParticipante" *ngIf="elementoVideo.userName">
                                             {{elementoVideo.userName}}</p>
                                        <video class="videoElement " *ngIf="elementoVideo.videollamada"
                                             [srcObject]="elementoVideo.videollamada"
                                             [muted]=" elementoVideo.idSocket == userVideoList[0].idSocket? true:false"
                                             playsinline autoplay></video>
                                        <div style="position: absolute;bottom: 2px;margin-left: 8%;">
                                        </div>
                                   </div>
                              </div>
                         </ng-container>


                    </div>
                    <div class="divVideosInferior col-md-2 p-0">
                         <ng-container *ngFor="let elementoVideo of userVideoList;">
                              <div *ngIf="elementoVideo.idSocket != userVideoSelected">
                                   <div class="video-container">
                                        <p class="nombreParticipante" *ngIf="elementoVideo.userName">{{
                                             elementoVideo.userName }}</p>
                                        <video class="videoElement" *ngIf="elementoVideo.videollamada"
                                             [srcObject]="elementoVideo.videollamada"
                                             [muted]="elementoVideo.idSocket == userVideoList[0].idSocket ? true : false"
                                             playsinline autoplay></video>
                                        <div style="position: absolute; bottom: 2px; margin-left: 8%;">
                                             <button data-toggle="tooltip" data-placement="top" title="Fijar usuario"
                                                  (click)="pinUser(elementoVideo)" class="buttonWithoutBorder">
                                                  <mat-icon class="buttonBar extendButton">push_pin</mat-icon>
                                             </button>
                                        </div>
                                   </div>
                              </div>
                         </ng-container>
                    </div>
               </div>
          </ng-container>
          <div class="contenedor-iconos-video" >
               <button data-toggle="tooltip" class="buttonWithoutBorder" data-placement="top"
                    [title]="!muteFlag? 'Desactivar micrófono':'Activar micrófono'" (click)='muteButtonFunction()'>
                    <mat-icon [ngClass]="{'buttonBar': true, 'buttonTrue': !muteFlag, 'buttonFalse': muteFlag}">
                         {{ muteFlag ? 'mic_off' : 'mic' }}
                    </mat-icon>
               </button>
               <button data-toggle="tooltip" data-placement="top"
                    [title]="!muteFlag? 'Desactivar cámara':'Activar cámara'" (click)='hideButtonFunction()'
                    class="centralButton buttonWithoutBorder">
                    <mat-icon
                         [ngClass]="{'buttonBar': true, 'buttonTrue': !hideCameraFlag, 'buttonFalse': hideCameraFlag}">
                         {{ !hideCameraFlag ? 'videocam' : 'videocam_off' }}
                    </mat-icon>
               </button>
               <button (click)='leaveButtonFunction();endMeeting()' class="buttonWithoutBorder" data-toggle="tooltip"
                    data-placement="top" title="Abandonar la llamada">
                    <mat-icon class=" buttonBar buttonFalse">call_end</mat-icon>
               </button>

          </div>
     </div>
</div> -->
<div class="card vc-card" style="margin: 0;
    width: -webkit-fill-available;">
     <div class="card-body p-0">


          <!-- Área de la llamada -->
          <div class="vc-stage" [ngClass]="{ 'active': !video_iniciado }">
               <!-- Si hay stream, pon aquí tus <video> -->
               <!-- <video class="vc-video" [srcObject]="localStream" playsinline autoplay muted></video> -->

               <!-- Placeholder mientras no hay video -->
               <div class="vc-placeholder" *ngIf="!(video_iniciado)">
                    <mat-icon>videocam</mat-icon>
               </div>
               <div *ngIf="video_iniciado" style="display: flex; justify-content: center;">
                    <ng-container *ngIf="userVideoList && userVideoList.length >0">

                         <div class="row contenerdor-pantallas w-100" [ngClass]="{ 'modo-video': isVideoView }">
                              <div class="divVideosInferior col-md-2 ">
                              </div>
                              <!-- Si es que tiene mas de un participante -->
                              <div class="divVideosSuperior col-md-8 p-0">
                                   <!-- Participantes de la fila superior -->
                                   <ng-container *ngFor="let elementoVideo of userVideoList;">
                                        <div class="videosSuperior" *ngIf="elementoVideo.idSocket == userVideoSelected">
                                             <div class="video-container">
                                                  <p class="nombreParticipante" *ngIf="elementoVideo.userName">
                                                       {{elementoVideo.userName}}</p>
                                                  <video class="videoElement " *ngIf="elementoVideo.videollamada"
                                                       [srcObject]="elementoVideo.videollamada"
                                                       [muted]=" elementoVideo.idSocket == userVideoList[0].idSocket? true:false"
                                                       playsinline autoplay></video>
                                                  <div style="position: absolute;bottom: 2px;margin-left: 8%;">
                                                       <!-- <button data-toggle="tooltip" data-placement="top" title="Fijar usuario" class="buttonWithoutBorder">
                                                  <mat-icon class="buttonBar extendButton">push_pin</mat-icon></button> -->
                                                  </div>
                                             </div>
                                        </div>
                                   </ng-container>


                              </div>
                              <div class="divVideosInferior col-md-2 p-0">
                                   <!-- Participante de la fila inferior -->
                                   <ng-container *ngFor="let elementoVideo of userVideoList;">
                                        <div *ngIf="elementoVideo.idSocket != userVideoSelected">
                                             <div class="video-container mb-2">
                                                  <div>
                                                       <p class="nombreParticipante" *ngIf="elementoVideo.userName">{{
                                                            elementoVideo.userName }}</p>
                                                  </div>
                                                  <video class="videoElement" *ngIf="elementoVideo.videollamada"
                                                       [srcObject]="elementoVideo.videollamada"
                                                       [muted]="elementoVideo.idSocket == userVideoList[0].idSocket ? true : false"
                                                       playsinline autoplay></video>
                                                  <div style="position: absolute; width: -webkit-fill-available; display: flex; justify-content: flex-end;" (click)="pinUser(elementoVideo)">
                                                       <button data-toggle="tooltip" data-placement="top"
                                                            title="Fijar usuario" 
                                                            class="buttonWithoutBorder">
                                                            <mat-icon class="buttonBar extendButton">push_pin</mat-icon>
                                                       </button>
                                                  </div>
                                             </div>
                                        </div>
                                   </ng-container>
                              </div>
                         </div>
                         <!-- </ng-container> -->
                    </ng-container>
               </div>
          </div>

          <!-- Footer / barra inferior -->
          <div class="vc-footer d-flex align-items-center justify-content-between">
               <div class="d-flex align-items-center vc-title">
                    <i class="fi fi-rr-video-camera-alt"
                         style="font-size: large; display: flex; justify-content: center;"></i>
                    <span class="ml-2" style="color: #808080 !important; font-family: 'Mulish';">Mi videoconsulta</span>
               </div>

               <div *ngIf="video_iniciado" class="d-flex align-items-center vc-actions">
                    <!-- Mic -->
                    <button type="button" class="vc-btn"
                         [attr.title]="!muteFlag ? 'Desactivar micrófono' : 'Activar micrófono'"
                         (click)="muteButtonFunction()">
                         <!-- <i style="font-size: large; display: flex; justify-content: center;"
                              [ngClass]="muteFlag ? 'fi fi-rr-microphone-slash' : 'fi fi-rr-microphone'"></i> -->
                         <mat-icon>{{ muteFlag ? 'mic_off' : 'keyboard_voice' }}</mat-icon>
                    </button>

                    <!-- Cámara -->
                    <button type="button" class="vc-btn ml-2"
                         [attr.title]="!hideCameraFlag ? 'Desactivar cámara' : 'Activar cámara'"
                         (click)="hideButtonFunction()">
                         <!-- <i style="font-size: large; display: flex; justify-content: center;"
                              [ngClass]="hideCameraFlag ? 'fi fi-rr-video-slash' : 'fi fi-rr-video-camera-alt'"></i> -->
                         <mat-icon>{{ !hideCameraFlag ? 'videocam' : 'videocam_off' }}</mat-icon>
                    </button>
                     <button *ngIf="usuario.typ_id === 2" (click)='leaveButtonFunction();endMeeting()' class="buttonWithoutBorder " data-toggle="tooltip"
                    data-placement="top" title="Abandonar la llamada">
                    <mat-icon class=" buttonBar buttonFalse">call_end</mat-icon>
               </button>

               </div>
               <div class="d-flex align-items-center vc-actions" >
                    <i class="d-none d-xl-inline-block" *ngIf="usuario.typ_id === 1"
                    [attr.title]="!isVideoView ? 'encoger pantalla' : 'agrandar pantalla'"
                    (click)="cambiarPantallaVideo()"
                    [ngClass]="!isVideoView ? 'fi fi-rr-expand' : 'fi fi-rr-compress'"
                         style="    font-size: large;"></i>
                    <!-- <mat-icon>{{ muteFlag ? 'fi fi-rr-microphone-slash' : 'fi fi-rr-microphone' }}</mat-icon> -->

               </div>
          </div>

     </div>
</div>